import { defaultInstance, directApiInstance } from './httpClient';

// UserEstateStatus interface based on the provided data
export interface UserEstateStatus {
  id: number;
  name: string;
  description: string;
}

// Response type for user_estate_status endpoint
export interface GetUserEstateStatus200 {
  data: UserEstateStatus[];
}

// Response type for updating user_estate
export interface UpdateUserEstate200 {
  data: any;
}

// Params for updating user_estate
export interface UpdateUserEstateParams {
  user_id: number;
  estate_id: number;
  status_id: number;
}

/**
 * Get all available user_estate_status records
 */
export const getUserEstateStatus = (signal?: AbortSignal) => {
  return defaultInstance<GetUserEstateStatus200>({
    url: '/user_estate_status',
    method: 'GET',
    signal
  });
};



/**
 * Update user_estate status - Direct PUT like the curl example
 */
export const updateUserEstateStatus = (
  params: UpdateUserEstateParams,
  signal?: AbortSignal
) => {
  return directApiInstance<UpdateUserEstate200>({
    url: '/user_estate',
    method: 'PUT',
    data: {
      user_id: params.user_id,
      estate_id: params.estate_id,
      status_id: params.status_id
    },
    signal
  });
}; 